export class Land {
    lid: number;
    annual: number;    /* ปีของข้อมูล */
    parcel_code: string;
    l_type: string;    /* รหัสประเภทที่ดิน  */
    dn: string;    /* เลขที่เอกสารสิทธิ์ */
    ln: string;    /* เลขที่ดิน */
    sn: string;
    sc: string;
    rw: string;
    lb: string;    /* เล่มที่ กรณี นส.3 */
    lp: string;    /* หน้าที่ กรณี นส.3 */
    moo: string;
    community: string;
    soi: string;
    road: string;
    tambon_id: string;
    r: string;     /* ไร่  */
    y: string;     /* งาน */
    w: string;     /* ตร.ว. */
    price: string; /* ราคาประเมินที่ดินต่อ ตร.ว. */
    notes: string; /* หมายเหตุ */
    uid : number;   /* รหัสคนเพิ่ม หรือแก้ไขข้อมูล */
    create_at : Date;   /* สร้างเมื่อ */
    modify_at : Date;   /* แก้ไขเมื่อ */
 }

export class Landused {
    annual: number;
    luid: number;
    lid: number;
    lu_type: number;
    u_r: string;
    u_y: string;
    u_w: string;
    owner_used: number;
    used_by: string;
    agri_type: string;
    agri_other: string;
    lu_notes: string;
    sub_lu_type: number;
    reduce: number;
    total_wa: number;
    special_type:number;
}

export class LandModel{
    land: Land;
    landOwner: any;
    landused: Landused;
    buildings: any;
}